import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { Popup } from 'ng2-opd-popup';
import { AdminService } from '../../services/admin';

declare var mdtoast: any;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast('Opération  effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });

@Component({
  selector: 'app-analyse',
  templateUrl: './analyse.component.html',
  styleUrls: ['./analyse.component.scss']
})
export class AnalyseComponent implements OnInit {
  @ViewChild('popupProcedure') popupProcedure: Popup;
  @ViewChild('popup5') popup5: Popup;
  listerdv_by_agent:any;
  
  constructor( public adminService: AdminService) { }

  ngOnInit() {

  }


   GetListeRDVOnLineParAgent() {
    this.adminService.getListeRDVParAgent(88)
      .subscribe(data => {
        this.listerdv_by_agent = data;
      }, err => {
        console.log(err);
      })
  }


  saveRDVOnLine2(rdvdate,rdvheure,rdvmotif){
    console.log("rendezVOus str datxxxe" + rdvdate + "rendezVOus4444 str date" +  rdvheure + "rendezVOus4444ddd str date" + rdvmotif);
    Swal.fire({
      title: 'Êtes-vous sûr?',
      icon: 'info',
      text: 'Une fois que vous cliquer sur Oui, vous ne pouvez plus revenir en arrière. S\'il vous plaît soyez certain.',
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Valider RDV!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        this.popup5.hide();
        success_message.show();return;    
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      //cancel btn
      }
    });
  }


  
  open() {
    this.popup5.options = { 
   
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Créer rendez-vous en ligne",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Ajouter",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
  }


  



  open2() {
    this.popupProcedure.options = { 
   
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Procédure Analyse ...",
      widthProsentage: 80,
      animation: "fadeInLeft",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);
  }

  fermerProcedure(){
    this.popupProcedure.hide();
  }

}
